import React from 'react';

interface StatCardProps {
  title: string;
  value: string | number;
  icon: React.ReactNode;
  trend?: {
    value: number;
    isPositive: boolean;
  };
  isAnimated?: boolean;
}

function StatCard({ title, value, icon, trend, isAnimated }: StatCardProps) {
  return (
    <div className={`bg-slate-800 rounded-xl p-5 shadow-lg ${isAnimated ? 'animate-pulse-custom' : ''}`}>
      <div className="flex justify-between mb-2">
        <h3 className="text-gray-400 text-sm font-medium">{title}</h3>
        <div className="text-blue-400">{icon}</div>
      </div>
      
      <div className="flex items-end space-x-2">
        <div className="text-2xl font-bold text-white">{value}</div>
        
        {trend && (
          <div className={`flex items-center text-sm ${trend.isPositive ? 'text-green-400' : 'text-red-400'}`}>
            <span className="mr-1">
              {trend.isPositive ? (
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M5.293 9.707a1 1 0 010-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L11 7.414V15a1 1 0 11-2 0V7.414L6.707 9.707a1 1 0 01-1.414 0z" clipRule="evenodd" />
                </svg>
              ) : (
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M14.707 10.293a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 111.414-1.414L9 12.586V5a1 1 0 012 0v7.586l2.293-2.293a1 1 0 011.414 0z" clipRule="evenodd" />
                </svg>
              )}
            </span>
            {trend.value}%
          </div>
        )}
      </div>
    </div>
  );
}

export default StatCard; 